import { c as e } from "react/compiler-runtime";
import { createContext as t, useContext as n, useId as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { FormattedMessage as o } from "react-intl";
//#region src/compatibility-router/router-context.ts
var s = t(null);
function c() {
	let e = n(s);
	if (!e) throw Error("`compatibility-router` hooks and components must be used inside <RouterProvider>");
	return e;
}
//#endregion
//#region src/compatibility-router/link.tsx
function l(e) {
	return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
}
function u(t) {
	let n = e(26), r, a, o, s, u, d, f;
	n[0] === t ? (r = n[1], a = n[2], o = n[3], s = n[4], u = n[5], d = n[6], f = n[7]) : ({to: f, params: o, search: u, onClick: a, target: d, children: r, ...s} = t, n[0] = t, n[1] = r, n[2] = a, n[3] = o, n[4] = s, n[5] = u, n[6] = d, n[7] = f);
	let { buildHref: p, navigate: m } = c(), h;
	n[8] !== p || n[9] !== o || n[10] !== u || n[11] !== f ? (h = p({
		to: f,
		params: o,
		search: u
	}), n[8] = p, n[9] = o, n[10] = u, n[11] = f, n[12] = h) : h = n[12];
	let g = h, _;
	n[13] !== m || n[14] !== a || n[15] !== o || n[16] !== u || n[17] !== d || n[18] !== f ? (_ = function(e) {
		a?.(e), !e.defaultPrevented && e.button === 0 && (l(e) || d && d !== "_self" || (e.preventDefault(), m({
			to: f,
			params: o,
			search: u
		})));
	}, n[13] = m, n[14] = a, n[15] = o, n[16] = u, n[17] = d, n[18] = f, n[19] = _) : _ = n[19];
	let v = _, y;
	return n[20] !== r || n[21] !== v || n[22] !== g || n[23] !== s || n[24] !== d ? (y = /* @__PURE__ */ i("a", {
		...s,
		href: g,
		onClick: v,
		target: d,
		children: r
	}), n[20] = r, n[21] = v, n[22] = g, n[23] = s, n[24] = d, n[25] = y) : y = n[25], y;
}
//#endregion
//#region src/compatibility-router/router-provider.tsx
function d(t) {
	let n = e(6), { children: r, navigate: a, buildHref: o } = t, c;
	n[0] !== o || n[1] !== a ? (c = {
		navigate: a,
		buildHref: o
	}, n[0] = o, n[1] = a, n[2] = c) : c = n[2];
	let l;
	return n[3] !== r || n[4] !== c ? (l = /* @__PURE__ */ i(s, {
		value: c,
		children: r
	}), n[3] = r, n[4] = c, n[5] = l) : l = n[5], l;
}
//#endregion
//#region src/compatibility-router/use-navigate.ts
function f() {
	let t = e(2), { navigate: n } = c(), r;
	return t[0] === n ? r = t[1] : (r = function(e) {
		let { to: t, params: r, search: i, replace: a } = e;
		n({
			to: t,
			params: r,
			search: i,
			replace: a
		});
	}, t[0] = n, t[1] = r), r;
}
//#endregion
//#region src/general/components/settings-side-panel.module.css
var p = "_content_1ke2a_17", m = {
	"side-panel": "_side-panel_1ke2a_1",
	"settings-header": "_settings-header_1ke2a_9",
	content: p
}, h = { link: "_link_1he2v_1" };
//#endregion
//#region src/general/components/settings-side-panel/link.tsx
function g(t) {
	let n = e(3), { to: r, children: a } = t, o;
	return n[0] !== a || n[1] !== r ? (o = /* @__PURE__ */ i("li", { children: /* @__PURE__ */ i(u, {
		className: h.link,
		to: r,
		children: a
	}) }), n[0] = a, n[1] = r, n[2] = o) : o = n[2], o;
}
var _ = { list: "_list_17ali_1" };
//#endregion
//#region src/general/components/settings-side-panel/list.tsx
function v(t) {
	let n = e(2), { children: r } = t, a;
	return n[0] === r ? a = n[1] : (a = /* @__PURE__ */ i("ul", {
		className: _.list,
		children: r
	}), n[0] = r, n[1] = a), a;
}
//#endregion
//#region src/general/components/settings-side-panel/section.tsx
function y(t) {
	let n = e(2), { children: r } = t, a;
	return n[0] === r ? a = n[1] : (a = /* @__PURE__ */ i("li", { children: r }), n[0] = r, n[1] = a), a;
}
var b = { title: "_title_kbl7u_1" };
//#endregion
//#region src/general/components/settings-side-panel/title.tsx
function x(t) {
	let n = e(2), { children: r } = t, a;
	return n[0] === r ? a = n[1] : (a = /* @__PURE__ */ i("h4", {
		className: b.title,
		children: r
	}), n[0] = r, n[1] = a), a;
}
//#endregion
//#region src/general/components/settings-side-panel.tsx
function S(t) {
	let n = e(9), { children: s } = t, c = r(), l;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ i(o, { id: "menu.settings" }), n[0] = l) : l = n[0];
	let u;
	n[1] === c ? u = n[2] : (u = /* @__PURE__ */ i("div", {
		className: m["settings-header"],
		children: /* @__PURE__ */ i("h4", {
			id: c,
			children: l
		})
	}), n[1] = c, n[2] = u);
	let d;
	n[3] === s ? d = n[4] : (d = /* @__PURE__ */ i("ul", {
		className: m.content,
		children: s
	}), n[3] = s, n[4] = d);
	let f;
	return n[5] !== c || n[6] !== u || n[7] !== d ? (f = /* @__PURE__ */ a("nav", {
		"aria-labelledby": c,
		className: m["side-panel"],
		children: [u, d]
	}), n[5] = c, n[6] = u, n[7] = d, n[8] = f) : f = n[8], f;
}
S.Section = y, S.Title = x, S.List = v, S.Link = g;
//#endregion
//#region src/daas-settings-side-panel.tsx
function C() {
	let t = e(3), n;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ i(S.Title, { children: /* @__PURE__ */ i(o, { id: "settings.section.personal_settings" }) }), t[0] = n) : n = t[0];
	let r;
	t[1] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ i(S.Link, {
		to: "/daas/$destinationId/settings/personal",
		children: /* @__PURE__ */ i(o, { id: "settings.personal.title" })
	}), t[1] = r) : r = t[1];
	let s;
	return t[2] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ i(S, { children: /* @__PURE__ */ a(S.Section, { children: [n, /* @__PURE__ */ a(S.List, { children: [r, /* @__PURE__ */ i(S.Link, {
		to: "/daas/$destinationId/settings/theme",
		children: /* @__PURE__ */ i(o, { id: "settings.theme.title" })
	})] })] }) }), t[2] = s) : s = t[2], s;
}
//#endregion
//#region src/hotel-settings-side-panel.tsx
function w() {
	let t = e(3), n;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ i(S.Title, { children: /* @__PURE__ */ i(o, { id: "settings.section.personal_settings" }) }), t[0] = n) : n = t[0];
	let r;
	t[1] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ i(S.Link, {
		to: "/hotel/$hotelId/settings/personal",
		children: /* @__PURE__ */ i(o, { id: "settings.personal.title" })
	}), t[1] = r) : r = t[1];
	let s;
	return t[2] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ i(S, { children: /* @__PURE__ */ a(S.Section, { children: [n, /* @__PURE__ */ a(S.List, { children: [r, /* @__PURE__ */ i(S.Link, {
		to: "/hotel/$hotelId/settings/theme",
		children: /* @__PURE__ */ i(o, { id: "settings.theme.title" })
	})] })] }) }), t[2] = s) : s = t[2], s;
}
//#endregion
//#region src/market-settings-side-panel.tsx
function T() {
	let t = e(3), n;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ i(S.Title, { children: /* @__PURE__ */ i(o, { id: "settings.section.personal_settings" }) }), t[0] = n) : n = t[0];
	let r;
	t[1] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ i(S.Link, {
		to: "/market/$marketId/settings/personal",
		children: /* @__PURE__ */ i(o, { id: "settings.personal.title" })
	}), t[1] = r) : r = t[1];
	let s;
	return t[2] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ i(S, { children: /* @__PURE__ */ a(S.Section, { children: [n, /* @__PURE__ */ a(S.List, { children: [r, /* @__PURE__ */ i(S.Link, {
		to: "/market/$marketId/settings/theme",
		children: /* @__PURE__ */ i(o, { id: "settings.theme.title" })
	})] })] }) }), t[2] = s) : s = t[2], s;
}
//#endregion
export { C as DaasSettingsSidePanel, w as HotelSettingsSidePanel, u as Link, T as MarketSettingsSidePanel, d as RouterProvider, f as useNavigate };
